 "use client";

import Image from "next/image";
import dynamic from "next/dynamic";
import { partners } from "@/lib/data";
import { LinkButton, TrustCard, ServiceList } from "../ui";
import styles from "./hero.module.css";

// Lazy load SocialLinks vì không critical cho LCP
const SocialLinks = dynamic(() => import("../ui/SocialLinks"), {
  ssr: true,
  loading: () => null,
});

// Lazy load StatsCard vì không phải LCP element để cải thiện LCP
const StatsCardLazy = dynamic(() => import("../ui/StatsCard"), {
  loading: () => null,
  ssr: true,
});

export default function HeroSection() {
  return (
    <section className={styles.heroSection}>
      <div className={styles.homeContainer}>
        <div className={styles.contentWrapper}>
          {/* Stats Card - Lazy load để cải thiện LCP vì không phải LCP element */}
          <div className={`${styles.fadeIn} ${styles.fadeInDelay1}`}>
            <StatsCardLazy
              icon="/assets/sdtc-image/icon/Vector 587.svg"
              iconAlt="Biểu tượng mũi tên tăng trưởng"
              title="Tăng trưởng hàng tuần"
              chartData="M0,185 C80,220 80,0 130,110 C200,240 200,220 240,50 C250,0 270,0 310,120 C350,240 370,170 400,90"
              stats={{
                number: "12345",
                percentage: "2.4%",
                arrowIcon: "/assets/sdtc-image/icon/Arrow 1.svg",
                arrowAlt: "Mũi tên tăng trưởng"
              }}
            />
          </div>

          {/* Main Content */}
          <div className={`${styles.introContent} ${styles.fadeIn} ${styles.fadeInDelay2}`}>
            <p className={styles.introSubtitle}>Designing With Us</p>
            <h1>
              <span className={styles.introHighlight}>Sea Dragon Technology</span>- Đối
              tác<br />
              thiết kế đáng tin cậy tại TP.HCM
            </h1>
            <p className={styles.introDescription}>
              Cùng chúng tôi thực hiện hoá ước mơ xây dựng sản phẩm của bạn,
              cùng nhau nói &quot;Có&quot; với những thiết kế phi thường.
            </p>
          </div>

          {/* Trust Card */}
          <div className={`${styles.fadeIn} ${styles.fadeInDelay3}`}>
            <TrustCard
              icon="/assets/sdtc-image/icon/Vector 588.svg"
              iconAlt="Biểu tượng mũi tên tăng trưởng"
              title="Khách hàng tin tưởng"
              avatars={[
                { src: "/assets/sdtc-image/trang-chu/people/image17.webp", alt: "Thành viên team 17" },
                { src: "/assets/sdtc-image/trang-chu/people/image16.webp", alt: "Thành viên team 16" },
                { src: "/assets/sdtc-image/trang-chu/people/image15.webp", alt: "Thành viên team 15" },
                { src: "/assets/sdtc-image/trang-chu/people/image14.webp", alt: "Thành viên team 14" },
                { src: "/assets/sdtc-image/trang-chu/people/image13.webp", alt: "Thành viên team 13" }
              ]}
              rating={{
                starIcon: "/assets/sdtc-image/icon/Star 3.svg",
                starAlt: "Ngôi sao đánh giá",
                rate: "1,234+"
              }}
            />
          </div>
        </div>

        {/* Services */}
        <div className={`${styles.serviceContainer} ${styles.fadeIn} ${styles.fadeInDelay2}`}>
          <ServiceList
            services={[
              { name: "UI/UX Design", icon: "/assets/sdtc-image/icon/dotblack.svg", iconAlt: "Chấm đen thống kê" },
              { name: "Prototype", icon: "/assets/sdtc-image/icon/dotblack.svg", iconAlt: "Chấm đen thống kê" },
              { name: "Web Design", icon: "/assets/sdtc-image/icon/dotblack.svg", iconAlt: "Chấm đen thống kê" },
              { name: "Landing Page", icon: "/assets/sdtc-image/icon/dotblack.svg", iconAlt: "Chấm đen thống kê" },
              { name: "Mobile Design", icon: "/assets/sdtc-image/icon/dotblack.svg", iconAlt: "Chấm đen thống kê" },
              { name: "Development", icon: "/assets/sdtc-image/icon/dotblack.svg", iconAlt: "Chấm đen thống kê" }
            ]}
          />
          <LinkButton
            href="/bang-gia"
            aria-label="Bắt đầu dự án ngay bây giờ"
          >
            Bắt đầu dự án
          </LinkButton>

          {/* Partners */}
          <div className={`${styles.partnerContainer} ${styles.fadeIn} ${styles.fadeInDelay3}`}>
            <SocialLinks
              links={[
                {
                  name: "TikTok",
                  href: "https://www.tiktok.com/@sea.dragon.techno",
                  icon: "/assets/sdtc-image/icon/social/Tiktok-white.svg",
                  alt: "TikTok"
                },
                {
                  name: "YouTube",
                  href: "https://www.youtube.com/@SeaDragonTechnology",
                  icon: "/assets/sdtc-image/icon/social/Youtube-white.svg",
                  alt: "YouTube"
                },
                {
                  name: "Instagram",
                  href: "https://www.instagram.com/seadragontechnology",
                  icon: "/assets/sdtc-image/icon/social/Instagram-white.svg",
                  alt: "Instagram"
                },
                {
                  name: "Facebook",
                  href: "https://www.facebook.com/congngherongbien",
                  icon: "/assets/sdtc-image/icon/social/Facebook-white.svg",
                  alt: "Facebook"
                }
              ]}
            />
            <div className={styles.partners}>
              <p>Đối tác tin cậy</p>
              <div className={styles.partnerList}>
                {partners.map((partner) => (
                  <div key={partner.id} className={styles.partnerItem}>
                    <Image
                      src={partner.image}
                      alt={`Partner ${partner.id}`}
                      width={320}
                      height={240}
                      sizes="(max-width: 768px) 70vw, 320px"
                      loading={partner.id === 1 ? "eager" : "lazy"}
                      priority={partner.id === 1}
                      fetchPriority={partner.id === 1 ? "high" : "low"}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}